/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	width: 100%;
	border: 2px solid #54678A;
	border-radius: 3px;
	margin-top: 21px;
`;


// WEBPACK FOOTER //
// ./src/components/auth-form/body.js